 <script setup>
import { onMounted, ref } from "vue";
import { toast } from "vue3-toastify";
import { useRouter } from "vue-router";
import BaseInput from "@/components/BaseInput.vue";
import axiosInstance from "@/utils/axiosInstance";
import { API_PATHS } from "@/utils/apiPaths";
import { userUserStore } from "@/store/useUserStore";
import Loading from "@/components/Loading.vue";

const email = ref("admin@admin.ac.mz");
const loading = ref(false);
const password = ref("password");
const error = ref("");
const errorEmail = ref("");
const errorPassword = ref("");
const userStore = userUserStore();
const router = useRouter();

const handleSubmit = async (e) => {
  e.preventDefault();
  loading.value = true;

  if (!email.value) {
    toast.info("Por favor informe o usuário", { autoClose: 1000 });
    loading.value = false;
    errorEmail.value = "Por favor informe o usuário";
    return;
  }
  if (!password.value) {
    toast.info("Por favor informe a senha", { autoClose: 1000 });
    errorPassword.value = "Por favor informe a senha";
    loading.value = false;
    return;
  }

  error.value = "";
  // Login API call
  try {
    const response = await axiosInstance.post(API_PATHS.AUTH.LOGIN, {
      email: email.value,
      password: password.value,
    });

    const token = response.data.access_token;
    if (token) {
      localStorage.setItem("token", token);
      let resp = await axiosInstance.get(API_PATHS.AUTH.GET_PROFILE);
      userStore.setUser(resp.data.data);
      console.log(resp?.data?.data?.role[0]);

      router.push(getRedirectPath(resp.data.data.role[0]));
    }
  } catch (error) {
    console.log(error);

    if (error?.response && error?.response?.data?.message) {
      error.value = error?.response?.data?.message;
    } else {
      error.value = error?.response?.data?.error;
    }
  } finally {
    loading.value = false;
  }
};

const getRedirectPath = (role) => {
  switch (role) {
    case "Admin":
    case "Secretaria":
    case "Master":
    case "Testers":
      return "/dashboard/";

    case "Professor":
      return "/teacher";

    case "Estudante":
      return "/student";

    default:
      return "/"; // fallback caso não reconheça
  }
};

const handleRecoverpassword = () => {
  router.push("/recover-password");
};
const goToSignup = () => {
  router.push("/inscription");
};

const handleSubmitDocumentInscription = () => {
  router.push("/complete-inscription");
};
onMounted(() => {
  const token = localStorage.getItem("token");

  if ((token != "undefined" || token != "") && userStore.user) {
    // if(){

    // }
    router.push("/dashboard");
  }
});
</script>

<template>
  <div>
    <div class="max-w-sm mx-auto bg-white py-4 rounded-md shadow-sm">
      <h3 class="text-2xl text-center font-bold">NDUKA</h3>
      <div class="mx-auto h-[65vh] px-3 md:-mt-16 flex flex-col justify-center">
        <div class="flex flex-col justify-center items-center w-full">
          <div
            class="w-[150px] h-[150px] flex flex-col items-center justify-center"
          >
            <img
              src="https://nduka.isupec.ac.mz/starter/assets/upload_images/20250323135237-isupec.png"
              class="max-w-full max-h-full object-contain"
              alt="forgotpassword"
            />
          </div>
          <h2 class="font-bold text-[14px]">Acesse a sua conta</h2>
        </div>

        <p v-if="error" class="text-red-500 text-xs text-center pb-2.5">
          {{ error }}
        </p>

        <form @submit.prevent="handleSubmit" class="mt-2">
          <BaseInput
            v-model="email"
            label="Usuário"
            placeholder="Ex:Usuário@ac.mz"
            type="text"
            :error="errorEmail"
            :disabled="false"
          />
          <BaseInput
            v-model="password"
            label="Senha"
            placeholder="Digite sua senha"
            type="password"
            :error="errorPassword"
            :disabled="false"
          />

          <div class="w-full flex justify-center">
            <button
              class="font-bold w-full shadow-md mx-auto p-2 mt-3 rounded-full text-white"
              style="background-color: #ed7431; color: #fff; border: none"
            >
              {{ loading ? "AGUARDE..." : "Entrar" }}
            </button>
          </div>
        </form>
        <div
          class="flex-row gap-2 justify-center cursor-pointer text-center mt-4"
        >
          <span class="text-sm font-semibold">
            Esqueceu a sua palavra-passe?
          </span>
          <span @click="handleRecoverpassword" class="text-sm text-blue-500">
            Clique aqui
          </span>
        </div>
      </div>
      <div class="bottom-0 text-center">
        <span>&copy; <strong>2025 | ISUPEC</strong></span>
      </div>
    </div>
    <div class="flex-row mt-3 gap-2 cursor-pointer justify-center text-center">
      <span class="text-md font-semibold">
        Ainda não fez a sua inscrição?
      </span>
      <span class="text-md text-blue-500" @click="goToSignup">
        Clique aqui
      </span>
      |
      <span @click="handleSubmitDocumentInscription" class="text-orange-400">
        Submeter documentos
      </span>
    </div>
    <Loading :loading-data="loading" />
  </div>
</template>
 

 